module.exports = __webpack_public_path__ + "img/error.66921536.svg";